import React from 'react';
import _ from 'lodash';
import { Typography, Tooltip } from 'antd';
import { SOURCE } from '@laigu/constants';
import { initVisitor } from '@laigu/utils';

import style from './index.less';

const { Paragraph } = Typography;
const { sourceMap } = SOURCE;

// 对话页
const ChatPage = props => {
  const { url, title, label } = props;
  if (url) {
    return (
      <section className={style['page-item']}>
        <div>
          <span className={style['page-item-title']}>{label}</span>
          <a title={title} target="_blank" href={url}>
            {title}
          </a>
        </div>
        <div className={style['page-item-content']}>
          <Paragraph ellipsis={{ rows: 2 }}>
            <Tooltip title={url} overlayClassName={style['tool-tip']}>
              {url}
            </Tooltip>
          </Paragraph>
        </div>
      </section>
    );
  }
  return '';
};

export const getFromPage = visitInfo => {
  const { first_visit_page_source_url_by_session, first_visit_page_source_keyword_by_session } = visitInfo;
  const sourceType = _.get(visitInfo, 'sourceInfo.type');
  const searchEngine = _.get(visitInfo, 'sourceInfo.searchEngine', '');
  if (sourceType === 'searchEngine' || sourceType === 'referral') {
    const searchEngineLabel = searchEngine ? String(sourceMap[searchEngine] ?? '') : '';
    let keyword = first_visit_page_source_url_by_session;
    if (first_visit_page_source_keyword_by_session) {
      keyword = `${searchEngineLabel} - ${first_visit_page_source_keyword_by_session}`;
    } else if (searchEngineLabel) {
      keyword = searchEngineLabel;
    }
    const url = first_visit_page_source_url_by_session;
    return {
      label: '来路页',
      url,
      title: keyword
    };
  }
  return null;
};

// 事件流展示来路页、着陆页、对话页
const ConvSource = props => {
  if (!props.data) {
    return null;
  }
  const { url: convUrl, title: convTitle, visit_info } = props.data;
  const visitInfo = initVisitor(visit_info);

  const {
    first_visit_page_url_by_session: firstVisitUrl,
    first_visit_page_title_by_session: firstVisitTitle,
    first_visit_page_source_url_by_session: firstVisitSource
  } = visitInfo;

  if (!firstVisitSource && !convUrl && !firstVisitUrl) {
    return null;
  }

  const pages = [
    getFromPage(visitInfo),
    {
      label: '着陆页',
      url: firstVisitUrl,
      title: firstVisitTitle
    },
    {
      label: '对话页',
      url: convUrl,
      title: convTitle
    }
  ].filter(val => val);

  return (
    <div className={style['page-box']}>
      {pages.map(val => {
        return <ChatPage {...val} key={val.label} />;
      })}
    </div>
  );
};

export default ConvSource;
